import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectCurrentPageEntities} from '@ngneat/elf-pagination';

import {clientsContractsStore} from '@store/clients/contracts/clients-contracts.store';

export const getClientsContractsDataSource = createRequestDataSource({
  store: clientsContractsStore,
  data$: () => clientsContractsStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getClientsContracts',
  dataKey: 'clientsContracts',
});